import React from 'react';
import { useHistory } from 'react-router-dom';

import { ReactComponent as CalendarIcon } from 'assets/images/calendar.svg';
import { ReactComponent as MobileChatIcon } from 'assets/images/mobile-chat.svg';
import { ReactComponent as UserProfileIcon } from 'assets/images/user-profile.svg';
import Header from 'components/AppBar';
import Loader from 'components/Loader';
import Preferences from 'components/Preferences';
import ProfileInfo from 'components/ProfileInfo';
import ProfilePhotoInfo from 'components/ProfilePhotoInfo';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { AccountResponse } from 'models/user';
import { formatISODateToDDMMYYYY } from 'utils/generic';

import { HeaderContainer, HeaderTitle, HeaderEdit, Container, Line, PreferencesTitle } from './styles';

interface TravelerUserProfile extends AccountResponse {
  nationality?: string;
}

interface Props {
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
  image?: string;
  user: TravelerUserProfile | null;
}

const TravelerProfile = ({ isLoading, setLoading, user, image }: Props) => {
  const history = useHistory();
  const { t } = useStoreTranslation();

  return (
    <>
      {isLoading ? (
        <Loader fullScreen />
      ) : (
        <>
          <Mobile>
            <Header goBack={() => history.push('/corporate/dashboard')}>
              <HeaderContainer>
                <HeaderTitle>{t('travelerFormProfile.title')}</HeaderTitle>
                <HeaderEdit onClick={() => history.push('/corporate/travelerProfileEdit')}>
                  {t('travelerProfile.edit')}
                </HeaderEdit>
              </HeaderContainer>
            </Header>
          </Mobile>

          <Desktop>
            <ScreenHeader
              title={t('travelerFormProfile.title')}
              subtitle={t('travelerFormProfile.headerTitle')}
              right={
                <HeaderEdit onClick={() => history.push('/corporate/travelerProfileEdit')}>
                  {t('travelerProfile.edit')}
                </HeaderEdit>
              }
            />
          </Desktop>

          <Container>
            <ProfilePhotoInfo
              imageSrc={image}
              isEdit={false}
              name={`${user?.name} ${user?.lastName}`}
              email={user?.email || ''}
            />
            <ProfileInfo icon={MobileChatIcon} title={t('travelerProfile.contact')} value={user?.phoneNumber ?? ''} />
            <ProfileInfo
              icon={CalendarIcon}
              title={t('travelerProfile.birthday')}
              value={
                new Date(user?.birthDate || '0001-01-01T00:00:00Z').toISOString() === '0001-01-01T00:00:00Z'
                  ? ''
                  : formatISODateToDDMMYYYY(user?.birthDate)
              }
            />
            <ProfileInfo
              icon={UserProfileIcon}
              title={t('travelerProfile.documentIdentity')}
              value={user?.documentNumber ?? ''}
            />
            {user?.passportNumber && (
              <ProfileInfo
                icon={UserProfileIcon}
                title={t('travelerProfile.documentPassport')}
                value={user?.passportNumber ?? ''}
              />
            )}

            <Line />

            <PreferencesTitle>{t('preferences.title')}</PreferencesTitle>
            <Preferences setLoading={setLoading} />
          </Container>
        </>
      )}
    </>
  );
};

export default TravelerProfile;
